var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 16.625H4.375C3.27043 16.625 2.375 15.7296 2.375 14.625V9.90112C2.375 9.38938 2.57115 8.89712 2.92309 8.52563L8.0481 3.1159C8.83695 2.28322 10.163 2.28322 10.9519 3.1159L16.0769 8.52563C16.4288 8.89712 16.625 9.38938 16.625 9.90111V14.625C16.625 15.7296 15.7296 16.625 14.625 16.625H11.0833M7.91667 16.625V12.375C7.91667 12.0989 8.14052 11.875 8.41667 11.875H10.5833C10.8595 11.875 11.0833 12.0989 11.0833 12.375V16.625M7.91667 16.625H11.0833",
    stroke: "black",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.eca9aee9d821c8f030a4627a4bdaf93e.svg";
export { ForwardRef as ReactComponent };